export default async function() {
  let sw = navigator?.serviceWorker
  if (!sw) return
  let registrations = await sw.getRegistrations()
  console.log("sw registrations",registrations)
  for(let registration of registrations) { await registration.unregister(); }
}
